"use client";

import { UspsSection } from "@/components/sections/usps";
import { usps } from "@/lib/data/services-social-media-intelligence";

export function Usps() {
  return (
    <UspsSection
      eyebrow={usps.eyebrow}
      title={usps.title}
      intro={usps.intro}
      usps={usps.usps}
      cta={usps.cta}
      accent={usps.accent}
      gridCols={usps.gridCols}
    />
  );
}
